import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import './ConfirmIcon.scss';

export function ConfirmIcon({ isConfirmed, className }: {isConfirmed: boolean, className?: string}) {
    return <>
        {!isConfirmed && (
            <FontAwesomeIcon
                icon="shield-alt"
                className={cn(className, "confirmIcon confirmIcon_notConfirmed")}
            />
        )}
        {isConfirmed && (
            <FontAwesomeIcon
                icon="check"
                className={cn(className, "confirmIcon confirmIcon_confirmed")}
            />
        )}
    </>;
}